import { render, staticRenderFns } from "./vendor-address.vue?vue&type=template&id=12a175c8&scoped=true&"
import script from "./vendor-address.component.ts?vue&type=script&lang=ts&"
export * from "./vendor-address.component.ts?vue&type=script&lang=ts&"
import style0 from "./vendor-address.vue?vue&type=style&index=0&id=12a175c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a175c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a175c8')) {
      api.createRecord('12a175c8', component.options)
    } else {
      api.reload('12a175c8', component.options)
    }
    module.hot.accept("./vendor-address.vue?vue&type=template&id=12a175c8&scoped=true&", function () {
      api.rerender('12a175c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/dashboard/components/Custom/vendor-address.vue"
export default component.exports